var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.001,
    height: 75.001,
    viewBox: "0 0 75.001 75.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00baef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07c87a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "step2",
    transform: "translate(-4 -218.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M-11489.5-8176a37.257,37.257,0,0,1-14.595-2.947,37.393,37.393,0,0,1-11.921-8.038,37.359,37.359,0,0,1-8.037-11.92,37.242,37.242,0,0,1-2.947-14.6,37.241,37.241,0,0,1,2.947-14.595,37.374,37.374,0,0,1,8.037-11.921,37.374,37.374,0,0,1,11.921-8.037A37.241,37.241,0,0,1-11489.5-8251a37.242,37.242,0,0,1,14.6,2.947,37.374,37.374,0,0,1,11.921,8.037,37.417,37.417,0,0,1,8.037,11.921A37.241,37.241,0,0,1-11452-8213.5a37.242,37.242,0,0,1-2.947,14.6,37.392,37.392,0,0,1-8.037,11.92,37.393,37.393,0,0,1-11.921,8.038A37.261,37.261,0,0,1-11489.5-8176Zm.688-47.3a2.855,2.855,0,0,1,2.372,1,4.588,4.588,0,0,1,.813,2.925c0,1.58-1.158,3.737-3.442,6.413l-9.3,10.079v4.507h20.2v-5.322h-11.4l3.737-4.438a49.715,49.715,0,0,0,4.328-4.912,15.262,15.262,0,0,0,1.979-3.5,9.569,9.569,0,0,0,.637-3.428,8.106,8.106,0,0,0-2.534-6.411c-1.685-1.486-4.117-2.239-7.229-2.239a10.766,10.766,0,0,0-5.288,1.308,9.629,9.629,0,0,0-3.7,3.64,10.108,10.108,0,0,0-1.327,5.068h6.717a5.672,5.672,0,0,1,.952-3.348A2.93,2.93,0,0,1-11488.812-8223.3Z",
    transform: "translate(11531 8469.285)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.c7d2967233ca8cbd597d160475ef738b.svg";
export { ForwardRef as ReactComponent };